<template>
  <div class="login">
    <logincomm>
      <span class="r-title">登陆 Login</span>
      <a-form @submit.prevent="doLogin"
              :autoFormCreate="(form) => this.form = form">
        <!-- <a-tabs size="large" :tabBarStyle="{textAlign: 'center'}" style="padding: 0 2px;" :activeKey="activeKey"
              @change="handleTabsChange">
        <a-tab-pane tab="账户密码登录" key="1">-->
        <a-alert type="error"
                 :closable="true"
                 v-show="error"
                 :message="error"
                 showIcon
                 style="margin-bottom: 24px;"></a-alert>
        <a-form-item fieldDecoratorId="name"
                     :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入账户名', whitespace: true}]}">
          <a-input size="large"
                   placeholder="请输入账户名">
            <a-icon slot="prefix"
                    type="user"></a-icon>
          </a-input>
        </a-form-item>
        <a-form-item fieldDecoratorId="password"
                     :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入密码', whitespace: true}]}">
          <a-input size="large"
                   type="password"
                   placeholder="请输入密码">
            <a-icon slot="prefix"
                    type="lock"></a-icon>
          </a-input>
        </a-form-item>
        <div class="pas-box">
          <a style="float: right; color:red"
             @click="findPassword">忘记密码?</a>
        </div>
        <a-form-item>
          <a-button :loading="loading"
                    style="width: 100%; margin-top: 4px; border-color: #40a9ff; color:#40a9ff"
                    size="large"
                    htmlType="submit">登录</a-button>
        </a-form-item>
        <!-- <div>
        <a style="float: right" @click="findPassword">找回密码</a>
        </div>-->
        <!--<div>
        <a style="float: right" @click="regist">注册账户</a>
        </div>-->
      </a-form>
    </logincomm>
  </div>
</template>

<script>
import logincomm from "../common/LoginComm";
import { mapMutations } from "vuex";
import db from "utils/localstorage";
import { loginParamId } from "@/router/index.js";
export default {
  components: { logincomm },
  name: "Login",
  data() {
    return {
      checkNick: true,
      loading: false,
      error: "",
      activeKey: "1",
      interval: "",
    };
  },
  computed: {
    systemName() {
      return this.$store.state.setting.systemName;
    },
    copyright() {
      return this.$store.state.setting.copyright;
    },
  },
  created() {
    // this.$db.clear()
    this.$router.options.routes = [];
  },
  methods: {
    findPassword() {
      this.$router.push({ path: "/findpassword" });
    },
    doLogin() {
      if (this.activeKey === "1") {
        // 用户名密码登录
        this.form.validateFields(["name", "password"], (errors, values) => {
          if (!errors) {
            this.loading = true;
            let name = this.form.getFieldValue("name");
            let password = this.form.getFieldValue("password");
            this.$post("login", {
              userName: name,
              password: password,
              tenantName: loginParamId,
            })
              .then((r) => {
                let data = r.data.data;
                // console.log('===== login data =====')
                // console.log(`user = ${JSON.stringify(data.user)}`);
                console.log("登录", data);
                this.saveLoginData(data);
                // if (this.interval) {                   //定时刷新Token
                //   clearInterval(this.interval)
                // }
                /* if (!this.interval) {
                  this.interval = setInterval(() => {
                    this.loopGetToken();
                  }, 7200000);
                } */
                /* if (!this.interval) {
                  this.interval = setInterval(() => {
                    this.loopGetToken();
                  }, 60000);
                } */
                setTimeout(() => {
                  this.loading = false;
                }, 500);
                this.$router.push("/");
              })
              .catch(() => {
                setTimeout(() => {
                  this.loading = false;
                }, 500);
              });
          }
        });
      }
      if (this.activeKey === "2") {
        // 手机验证码登录
        this.$message.warning("暂未开发");
      }
    },
    regist() {
      this.$emit("regist", "Regist");
    },
    getCaptcha() {
      this.$message.warning("暂未开发");
    },
    /* loopGetToken() {
      let token = db.get("USER_TOKEN");
      this.$get("refreshToken", {
        Authentication: token
      }).then(r => {
        this.setToken(r.data.token);
        this.setExpireTime(r.data.expireTimeStr);
      });
    }, */
    handleTabsChange(val) {
      this.activeKey = val;
    },
    ...mapMutations({
      setToken: "account/setToken",
      setExpireTime: "account/setExpireTime",
      setRefreshToken: "account/setRefreshToken",
      setRefreshTokenExpireTime: "account/setRefreshTokenExpireTime",
      setPermissions: "account/setPermissions",
      setRoles: "account/setRoles",
      setUser: "account/setUser",
      setTheme: "setting/setTheme",
      setLayout: "setting/setLayout",
      setMultipage: "setting/setMultipage",
      fixSiderbar: "setting/fixSiderbar",
      fixHeader: "setting/fixHeader",
      setColor: "setting/setColor",
      setDefaultMap: "setting/setDefaultMap",
    }),
    saveLoginData(data) {
      this.setToken(data.accessToken);
      this.setExpireTime(data.accessTokenExipreTime);
      this.setRefreshToken(data.refreshToken);
      this.setRefreshTokenExpireTime(data.refreshTokenExipreTime);
      this.setUser(data.user);
      this.setPermissions(data.permissions);
      this.setRoles(data.roles);
      this.setTheme(data.config.theme);
      this.setLayout(data.config.layout);
      this.setMultipage(data.config.multiPage);
      this.fixSiderbar(data.config.fixSiderbar === "1");
      this.fixHeader(data.config.fixHeader === "0");
      this.setColor(data.config.color);
      this.setDefaultMap(data.config.defaultMap || 0);
    },
  },
};
</script>

<style lang="less" scoped>
.r-title {
  display: inline-block;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 15px;
}
.login {
  .pas-box {
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  .icon {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.2);
    margin-left: 16px;
    vertical-align: middle;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #1890ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue